/* eslint-disable react/no-danger */
import React from "react";
import { string, oneOfType, number, objectOf, object, shape, array } from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../../sharedComponents/Link";
import * as styles from "./BlogCard.module.scss";

const BlogCard = ({ image, header, content, className, style, link }) => (
	<Card className={cx(className)} style={style}>
		{image && (
			<div className={cx(styles.imageLink)}>
				<Card.Image src={image.src} fluid={image.fluid} alt={image.alt} />
				<Link to={link?.to} target={link?.target}>
					<span className="sr-only">{link.text}</span>
				</Link>
			</div>
		)}
		{header && (
			<Card.Header className={cx(styles.blogHeading)}>
				<Link to={link?.to} target={link?.target}>
					{header}
				</Link>
			</Card.Header>
		)}
		{content && (
			<Card.BodyContainer>
				<div>
					<Card.Content>
						<Link to={link?.to} target={link?.target}>
							<span dangerouslySetInnerHTML={{ __html: content }} />
						</Link>
					</Card.Content>
				</div>
			</Card.BodyContainer>
		)}
	</Card>
);

BlogCard.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}),
	header: string,
	content: string,
	className: string,
	link: shape({
		to: string,
		target: string,
	}),
	style: objectOf(oneOfType([string, number])),
};

BlogCard.defaultProps = {
	header: "",
	image: null,
	content: "",
	className: "",
	link: {
		to: "#",
		target: "_self",
	},
	style: {},
};

export default BlogCard;
export { BlogCard };
